import './sass/style.scss'

jQuery(window).scroll((e) => {
    const $header = jQuery('.main-header');

    if(jQuery(window).scrollTop() > $header.height() + 70) {
        $header.addClass('scroll');
    } else {
        $header.removeClass('scroll');
    }
});

jQuery(document).ready(() => {
    jQuery('.wp-block-alto-transver-alto-steps').on('wheel', function(e) {
        const delta = e.originalEvent.deltaY;
        if (delta !== 0 && inHorizontalScrollRange(delta, e.delegateTarget)) {
            e.preventDefault();
    
            this.scrollBy({ left: delta });
    
            return false;
        }
    });

});

/**
 * Checks if the vertical scroll amount should be redirected to horizontal scrolling
 * Returns false if the scroll direction is upward and the target is already at the leftmost scroll position
 * or if the scroll direction is downward and the target is already at the rightmost scroll position
 * 
 * @param {number} delta The vertical scroll amount
 * @param {Element} target The element to be scrolled horizontally
 * @returns {bool} Whether to scroll horizontally
 */
 function inHorizontalScrollRange(delta, target)
 {
    const scrollMax = target.scrollLeftMax ? target.scrollLeftMax : target.scrollWidth - target.offsetWidth;
     return (delta < 0 && target.scrollLeft !== 0) || (delta > 0 && target.scrollLeft < scrollMax)
 }

/**
 * Returns a random positive integer between 0 (inclusive) and the given range parameter (exclusive)
 * 
 * @param {int} range The upper limit of of the possible numbers (exclusive)
 * @returns {int}
 */
function randomUInt(range) {
    return Math.floor(Math.random() * range);
}

jQuery.fn.random = function() {
    return jQuery(this[randomUInt(this.length)]); 
};

/**
 * Pseudo Tag-Cloud contents
 */
const cloudType = {
    transport: [
        'Transport',
        'Liikennen',
        'Dopravy' ,
        'Trasporto',
        'Транспорт',
        'Szállítás',
        'μεταφορά',
        'Prijevoz',
        'Kuljetus',
        'Ulaşim',
        'Vervoer',
        'Neqilkirin'
    ],
    country: [
        'DE',
        'IT',
        'FR',
        'CH',
        'NL',
        'PL',
        'CZ'
    ],
    seafreight: [
        'Sea freight',
        'Seefracht',
        'Fret maritime',
        'Fracht morski',
        'zeevracht',
        'θαλάσσιο φορτίο',
        'морской фрахт',
        'søfragt',
        'поморски терет'
    ]
}

/**
 * Pseudo Tag-Cloud process
*/
jQuery(document).ready(() => {
    const anim = () => {
        const running = jQuery('.alto-cloud-flash')
            .filter((id, el) => jQuery(el).data('running'))
            .length;

        if (running < 3) {
            const $elem = jQuery('.alto-cloud-flash').random();

            if (!$elem.data('running')) {
                $elem.data('running', true);

                const type = $elem.data('type');
                const variations = type in cloudType ? cloudType[type] : cloudType.seafreight;

                const ba = baffle($elem.get(0), {
                    characters: variations.join('').replace(' ', ""),
                    speed: 100
                });
                
                // Start the baffle reveal and remove the 'running' data once it is finished
                const timeToReveal = randomUInt(3500) + 500;
                ba.start()
                    .text(() => variations[randomUInt(variations.length)])
                    .reveal(timeToReveal);
                setTimeout(() => $elem.data('running', false), timeToReveal);

                // Queue up next animation with a random timeout (> 500ms)
                setTimeout(anim, randomUInt(4500) + 500);

            } else {
                anim();
            }
        } else {
            setTimeout(anim, 200);
        }
    }

    if (jQuery('.wp-block-alto-transver-alto-cloud').length > 0) {
        setTimeout(anim, 200);
        setTimeout(anim, 400);
        setTimeout(anim, 600);
    }
})

